import React, { useCallback, useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import { ATMField, ATMInput } from 'shared-it-appmod-ui';
import { IRequestFormMethods } from 'src/models/request.model';
import FileManager from 'src/components/molecules/file-manager/file-manager.component';
import { FileCategory } from 'src/constants';
import { IFile } from 'src/models/file.model';

type IProps = IRequestFormMethods & {
  name: string;
  inline?: boolean;
  allowedTypes?: FileCategory[];
  min?: number;
  fileRestriction?: string[];
};

const FormUpload: React.FC<IProps> = ({
  control,
  inline = false,
  name,
  allowedTypes,
  min,
  fileRestriction,
}) => {
  const { fields, append, remove } = useFieldArray<IFile>({
    control,
    name,
  });

  const handleAdd = useCallback(() => {
    append({ id: undefined });
  }, [append]);

  useEffect(() => {
    if (!fields.length && min) {
      Array(min)
        .fill(null)
        .forEach(() => {
          handleAdd();
        });
    }
  }, [fields, min, handleAdd]);

  const handleUpdate = useCallback(
    (data) => {
      remove();
      append(data);
    },
    [append, remove]
  );

  return (
    <>
      {fields.map((item, i) => (
        <>
          {item.uploadId && (
            <ATMField
              key={`id_${name}_${i}_${item.fileName}`}
              name={`${name}[${i}].uploadId`}
              defaultValue={item.uploadId}
              className="hidden"
              as={ATMInput}
              control={control}
              type="hidden"
            />
          )}
          <ATMField
            key={`uploadTypeId_${name}_${i}_${item.fileName}`}
            name={`${name}[${i}].uploadTypeId`}
            defaultValue={item.uploadTypeId}
            className="hidden"
            as={ATMInput}
            control={control}
            type="hidden"
          />
          <ATMField
            key={`filename_${name}_${i}_${item.fileName}`}
            name={`${name}[${i}].fileName`}
            defaultValue={item.fileName}
            className="hidden"
            as={ATMInput}
            control={control}
            type="hidden"
          />
          <ATMField
            key={`docName_${name}_${i}_${item.fileName}`}
            name={`${name}[${i}].docName`}
            defaultValue={item.docName}
            className="hidden"
            as={ATMInput}
            control={control}
            type="hidden"
          />
        </>
      ))}

      <FileManager
        files={fields as IFile[]}
        allowedTypes={allowedTypes}
        inline={inline}
        onUpdate={handleUpdate}
        fileRestriction={fileRestriction}
      />
    </>
  );
};

export default FormUpload;
